import React from "react";
import "./visa.css";
import { ComplexTable } from "../Home/Tables/complexTable";

export const PaymentandFees = () => {
  // Table 1 data
  const col1_1 = ["Acadmic attendee", "Student attendee", "General attendee"];

  const col1_2 = ["800,000", "550,000", "950,000"];

  const col1_3 = ["950,000", "650,000", "1000,000"];

  const col1_4 = ["400,000", "350,000", "400,000"];

  const col1_5 = ["450,000", "400,000", "500,000"];

  const col1_6 = ["75,000", "75,000", "150,000"];

  // Table 2 data
  const col2_1 = ["Acadmic attendee", "Student attendee", "General attendee"];

  const col2_2 = ["$ 600", "$ 400", "$ 700"];

  const col2_3 = ["$ 700", "$ 500", "$ 800"];

  const col2_4 = ["$ 250", "$ 250", "$ 300"];

  const col2_5 = ["$ 300", "$ 300", "$ 400"];

  const col2_6 = ["$ 50", "$ 50", "$ 100"];

  return (
    <>
      <div className="visa-big-box container">
        <div className="heading">
          <h1>
            Author Registration Fees – Request an invoice for the late
            registration
          </h1>
        </div>
        <ComplexTable
          currencytype={"won"}
          col1={col1_1}
          col2={col1_2}
          col3={col1_3}
          col4={col1_4}
          col5={col1_5}
          col6={col1_6}
        />
        <ComplexTable
          currencytype={"USD"}
          col1={col2_1}
          col2={col2_2}
          col3={col2_3}
          col4={col2_4}
          col5={col2_5}
          col6={col2_6}
        />
        <br />
        <hr className="hr-style" />
        <br />
        <br />
        <h3>
          Bank Details for International Authors
        </h3>
        <h5 className="information">
          학회 계좌이체 정보 공유합니다. (Bank Transfer Information)
        </h5>
        <ul>
          <li>
            Bank Name (은행명) :{" "}
            <b style={{ textDecoration: "none", color: "#FF9933" }}>
              BUSAN BANK, Foreign Business Department
            </b>
          </li>
          <li>
            Bank Address (은행주소):{" "}
            <b style={{ textDecoration: "none", color: "#FF9933" }}>
              30 MUNHYEONGEUMYUNG-RO, NAM-GU, BUSAN, KOREA
            </b>
          </li>
          <li>
            SWIFT CODE (은행 SWIFT CODE):{" "}
            <b style={{ textDecoration: "none", color: "#FF9933" }}>
              PUSBKR2P
            </b>
          </li>
          <li>
            Beneficiary's Name (고객님 이름):{" "}
            <b style={{ textDecoration: "none", color: "#FF9933" }}>
              The Korea Institute of Convergence Signal Processing
            </b>
          </li>
          <li>
            Beneficiary's A/C NO. (고객님 계좌번호):{" "}
            <b style={{ textDecoration: "none", color: "#FF9933" }}>
              101-2071-8783-02
            </b>
          </li>
          <li>
            Beneficiary's Address (고객님 주소):{" "}
            <b style={{ textDecoration: "none", color: "#FF9933" }}>
              708 UIT, 47, Jurye-ro, Sasang-gu, Busan
            </b>
          </li>
        </ul>
        {/* <h3 style={{ width: "100%" }}>PayPal payment :</h3>
        <h5 style={{ marginLeft: "40px" }}>
        <Link to="mailto:ihcisociety@gmail.com">ihcisociety@gmail.com</Link>
        </h5> */}
      </div>
      <hr className="hr-style" />
    </>
  );
};
